export default "__VITE_ASSET__BD$jEu2U__"